var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isHeaderHidden)?_c('VipHeader',{class:_vm.headerClass,attrs:{"keyNum":new Date().getTime()}}):_vm._e(),_c('router-view'),(!_vm.isFooterHidden)?_c('VipFooter'):_vm._e(),_c('VipTools',{attrs:{"ts":new Date().getTime()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }